import { gql, useMutation } from "@apollo/client";

const CREATE_DESIGNER_BIO = gql`
  mutation CreateDesignerBio(
    $designerId: String!
    $userName: String
    $yearsExperience: Int
    $aboutMe: String
    $education: [String]
    $whyWorkWithMe: String
    $designAdvice: String
    $favoriteMovie: String
    $favoriteMusicGenre: String
    $favoriteBook: String
    $currentlyReading: String
    $image: ID
    $coverImage: ID
    $coverImagePositionX: Float
    $coverImagePositionY: Float
    $reviews: [DesignerReviewInput!]
  ) {
    createDesignerBio(
      designerId: $designerId
      userName: $userName
      yearsExperience: $yearsExperience
      aboutMe: $aboutMe
      education: $education
      whyWorkWithMe: $whyWorkWithMe
      designAdvice: $designAdvice
      favoriteMovie: $favoriteMovie
      favoriteMusicGenre: $favoriteMusicGenre
      favoriteBook: $favoriteBook
      currentlyReading: $currentlyReading
      image: $image
      coverImage: $coverImage
      coverImagePositionX: $coverImagePositionX
      coverImagePositionY: $coverImagePositionY
      reviews: $reviews
    ) {
      _id
      userName
      yearsExperience
      aboutMe
      education
      whyWorkWithMe
      designAdvice
      favoriteMovie
      favoriteMusicGenre
      favoriteBook
      currentlyReading
      coverImage
      coverImagePositionX
      coverImagePositionY
      designerId
      image
      reviews {
        id
        rating
        text
        author
        location
        avatar
        source
        createdAt
      }
    }
  }
`;

export const useCreateDesignerBioMutation = () => {
  const [createDesignerBioMutation, { loading, error, data }] =
    useMutation(CREATE_DESIGNER_BIO);

  const createDesignerBio = async (args: any) => {
    try {
      const { data } = await createDesignerBioMutation({
        variables: args,
      });
      return data?.createDesignerBio;
    } catch (err) {
      console.error("Error creating designer bio:", err);
      throw err;
    }
  };

  return {
    createDesignerBio,
    loading,
    error,
    data,
  };
};
